import axios from "axios";
import cookie from "js-cookie";

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL, // Set your API base URL in environment variables
  headers: {
    "Content-Type": "application/json",
  },
});

// Add an interceptor to include the token in the headers
api.interceptors.request.use(
  (config) => {
    const token = cookie.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add a response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => {
    // Return the response if it's successful
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401 && error.config.url !== "authentication/verify_token") {
      // If a 401 error is returned, delete the token and redirect to the login page
      cookie.remove("token");
    }
    return Promise.reject(error);
  }
);

// Define generic API methods
export const get = async (url, params = {}) => {
  try {
    const response = await api.get(url, { params });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const post = async (url, data) => {
  try {
    const response = await api.post(url, data);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const put = async (url, data) => {
  try {
    const response = await api.put(url, data);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const patch = async (url, data) => {
  try {
    const response = await api.patch(url, data);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const del = async (url) => {
  try {
    const response = await api.delete(url);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postFiles = async (data) => {
  const formData = new FormData();
  formData.append("file", data?.file);
  formData.append("field_name", data?.type);

  const res = await api.post(`/file-upload`, formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return res;
};

export default api;
